import request from '@/utils/request'

const wxApi = {
  getAuthInfo: (authCode) => {
    const data = {
      authCode: authCode
    }
    return request({
      url: '/public/wx/authorize',
      method: 'post',
      data
    })
  },
  getJsConfig: (url) => {
    const data = {
      url: url
    }
    return request({
      url: '/public/wx/jsapi/config',
      method: 'post',
      data
    })
  }
}

export default wxApi
